var React = require('react');

function WhiteChevronRight (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"n-icons/chevron-right"},React.createElement("path",{"id":"Vector","d":"M4.5 9L7.5 6L4.5 3","stroke":"white","strokeMiterlimit":"10","strokeLinecap":"round","strokeLinejoin":"round"})));
}

WhiteChevronRight.defaultProps = {"width":"12","height":"12","viewBox":"0 0 12 12","fill":"none"};

module.exports = WhiteChevronRight;

WhiteChevronRight.default = WhiteChevronRight;
